import { Z_INDEX_MODAL } from '@/features/shared/constants/global'
import { css } from '@/features/shared/styles'
import { createGlobalStyle } from 'styled-components'
import { keyframesGlobalStyle } from '@/features/shared/styles/effects/keyframesGlobalStyle'

export const whiteGradient = css`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 255) 100%);
`

export const focusStyles = css`
  // Default
  outline-color: black;
  outline-style: dashed;
  outline-width: 1px;
  outline-offset: 1px;
  // Outline Radius - Mozilla Only
  -moz-outline-radius: 4px;
`

export const GlobalStyle = createGlobalStyle`
  html,
  body,
  div,
  article,
  section,
  main,
  footer,
  header,
  form,
  fieldset,
  legend,
  pre,
  code,
  a,
  h1,h2,h3,h4,h5,h6,
  p,
  ul,
  ol,
  li,
  dl,
  dt,
  dd,
  textarea,
  table,
  td,
  th,
  tr,
  input[type="email"],
  input[type="number"],
  input[type="password"],
  input[type="tel"],
  input[type="text"],
  input[type="url"],
  .border-box {
    box-sizing: border-box;
  }

  img { max-width: 100%; }

  html {
    background-color: ${({ theme }) => theme.white};
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-smooth: never;
}
  
  html,
  body {
    min-height: 100%;
    width: 100%;
  }
  
  // Extend tachyons positions
  .sticky {
    position: sticky;
  }

  // Use system font stack across the app
  body,
  button,
  input,
  optgroup,
  select,
  textarea {
      font-family: Euclid Circular A, system-ui, sans-serif;
      letter-spacing: 0;
  }
  
  // Global styles used for transcend consent manager banner
  #transcend-consent-manager {
    z-index: ${Z_INDEX_MODAL - 1} !important;
  }

  // global style for react modal
  .ReactModal__Body--open {
    overflow: hidden;
  }
  
  // global style for keyboard users
  .is-keyboarduser .hide-keyboarduser {
    display: none;
  }
  a:focus,
  button:focus,
  input:focus,
  textarea:focus,
  select:focus,
  li:focus,
  [tabindex='0']:focus,
  [tabindex='-1']:focus,
  label:focus-within {
    ${focusStyles}
  }

  body:not(.is-keyboarduser) *:focus, 
  body:not(.is-keyboarduser) label:focus-within {
    outline: none;
  }

  ${keyframesGlobalStyle}

  ${process.env.IS_AUTOMATION ? 'nextjs-portal { display: none }' : ''}
`
